import { render, staticRenderFns } from "./textFloat.vue?vue&type=template&id=ab8a41c4&scoped=true&"
import script from "./textFloat.vue?vue&type=script&lang=js&"
export * from "./textFloat.vue?vue&type=script&lang=js&"
import style0 from "./textFloat.vue?vue&type=style&index=0&id=ab8a41c4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab8a41c4",
  null
  
)

export default component.exports